// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu {\n  height: 100%;\n  padding-top: 27px;\n  position: relative;\n  z-index: 2;\n}\n.menu-list > li > a,\n.menu-list--2 > li > a {\n  color: white;\n  padding: 16px 0 16px 30px;\n  font-size: 16px;\n  border-right: 2px transparent solid;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n.menu-list--2 {\n  margin: 14px 0 14px 18px;\n  transition: all 0.3s ease-in-out;\n}\n", ""]);
// Exports
module.exports = exports;
